<div class="outest" *ngIf="profile">
  <!-- profile wall image -->
  <div
    class="profile-wall-image"
    fxLayout="row"
    fxLayoutAlign="center center"
    [style.background-image]="profile.profileWallImage ? profile.profileWallImage.safe : ''"
  >
    <!-- hidden file upload input -->
    <input
      #wallImageInput
      type="file"
      accept="image/*"
      (change)="uploadProfileImage(wallImageInput, purposeKeyPrefix + '_WALL_IMAGE')"
      style="display: none"
    />

    <!-- btn edit -->
    <small-round-btn
      *ngIf="!editDisabled && !disabled"
      style="position: absolute; left: 5px; top: 5px"
      icon="fal fa-camera"
      [click]="pressWallImageUploadBtn.bind(this)"
    ></small-round-btn>

    <!-- btn delete -->
    <small-round-btn
      *ngIf="!editDisabled && !disabled && profile.profileWallImage"
      style="position: absolute; left: 5px; top: 45px"
      icon="fas fa-trash-alt"
      [click]="deleteWallImage.bind(this)"
    ></small-round-btn>

    <div class="editError" *ngIf="editDisabled">
      Bitte schließe erst den aktuellen Profil Bearbeitungsvorgang ab bevor Du deine Bilder änderst.
    </div>
  </div>

  <!-- name bar -->
  <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px" class="name-bar" fxLayout.gt-md="row">
    <!-- name / certified / level -->
    <div fxFlex="noshrink" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" style="padding: 10px 0px">
      <div>{{ profile?.getName() }}</div>
      <div *ngIf="profile.isCertified()">
        <i class="fas fa-check-circle certifiedCheckmark"></i>
      </div>
    </div>

    <!-- level -->
    <div
      *ngIf="level"
      fxFlex="grow"
      fxLayout="column"
      fxLayout.gt-sm="row"
      fxLayoutAlign="end center"
      fxLayoutGap="10px"
      style="font-size: 20px"
    >
      <div (click)="gotoBonusFaq()" style="cursor: pointer">{{ level.title }}</div>

      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end center">
        <div [style.background-image]="'url(' + level.image + ')'" class="levelimage"></div>
      </div>
    </div>
  </div>

  <!-- profile image - positioned absoloute -->
  <div
    class="profile-image"
    [class.containProfileImage]="containProfileImage"
    fxLayout="row"
    fxLayoutAlign="center center"
    [style.backgroundImage]="
      profile.profileImage
        ? profile.profileImage.safe
        : 'url(' + environment.publicFolder + 'assets/images/no_user_image.jpg)'
    "
  >
    <!-- change buttons -->
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
      <!-- hidden file upload input -->
      <input
        #profileImageInput
        type="file"
        accept="image/*"
        (change)="uploadProfileImage(profileImageInput, purposeKeyPrefix + '_IMAGE')"
        style="display: none"
      />

      <!-- btn edit mobile -->
      <small-round-btn
        *ngIf="!editDisabled && !disabled"
        style="position: absolute; right: 0px"
        icon="fal fa-camera"
        [style.bottom]="profile.profileImage ? '30px' : '0px'"
        [click]="pressProfileImageUploadBtn.bind(this)"
      >
      </small-round-btn>

      <!-- btn delete mobile -->
      <small-round-btn
        *ngIf="!editDisabled && !disabled && profile.profileImage"
        style="position: absolute; right: 0px; bottom: 0px"
        icon="fas fa-trash-alt"
        [click]="deleteProfileImage.bind(this)"
      >
      </small-round-btn>
    </div>
  </div>
</div>
